import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Table, TableBody, TableRow, TableCell, TableContainer, TableFooter, TablePagination, TableHead, IconButton, Collapse, Chip, Tooltip, ListItem, List } from "@mui/material";
import { Fragment, useState } from "react";

const CollapsibleTableRow = (props) => {
    const [open, setOpen] = useState(false);
    const { data, headKeys, headTransforms, childFunc, cellsx } = props;

    return (
        <Fragment>
            <TableRow>
                <TableCell sx={{ padding: 1, border: 0 }}>
                    <IconButton
                        size="small"
                        onClick={() => setOpen((po) => !po)}
                    >
                        {open ? <KeyboardArrowUp sx={cellsx} /> : <KeyboardArrowDown sx={cellsx} />}
                    </IconButton>
                </TableCell>
                {headKeys.map((th, idx) => (
                    <TableCell key={idx} sx={{
                        maxWidth: { xs: 50, sm: "36vw", md: "24vw", lg: "12vw" },
                        wordWrap: "break-word",
                        padding: 1,
                        textTransform: headTransforms && headTransforms[idx],
                        ...cellsx,
                        border: 0,
                        fontFamily: "inter",
                    }}>
                        {data[th] instanceof Array ? (
                            <List>
                                {data[th].map((td, idx) => <Tooltip title={td || 'UNKNOWN'} arrow key={idx}>
                                    <ListItem sx={{ padding: "2px" }}>
                                        <Chip
                                            key={idx}
                                            // sx={{fontSize: "large"}}
                                            label={td || '-'}
                                        />
                                    </ListItem>
                                </Tooltip>)}
                            </List>) : data[th] || 'UNKNOWN'}
                    </TableCell>
                ))}
            </TableRow>
            <TableRow>
                <TableCell sx={{ paddingY: 0 }} colSpan={headKeys.length + 1}>
                    <Collapse in={open} timeout="auto">
                        {childFunc && childFunc(data)}
                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    );
}

export default function CollapsibleTable(props) {
    const { heads, data, size, ...rowProps } = props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    return (
        <TableContainer>
            <Table size={size}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ paddingX: 1, ...props.cellsx }} />
                        {heads.map((th, idx) => (
                            <TableCell key={idx} sx={{ 
                                paddingX: 1, 
                                ...props.cellsx,
                                fontFamily: "montserrat", 
                                fontWeight: 600,
                            }}>{th}</TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data && data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((rowdata, idx) => (
                        <CollapsibleTableRow
                            key={idx}
                            data={rowdata}
                            rowProps
                            {...rowProps}
                        />
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            count={data && data.length}
                            rowsPerPageOptions={[5, 10, 20]}
                            page={page}
                            onRowsPerPageChange={(event) => {
                                setRowsPerPage(event.target.value);
                                setPage(0);
                            }}
                            onPageChange={(_, newPage) => setPage(newPage)}
                            rowsPerPage={rowsPerPage}
                            sx={{
                                "& .MuiToolbar-regular": {
                                    width: "max-content"
                                },
                                ...props.cellsx,
                                border: 0,
                            }}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}